import { Site } from 'graphql-api/gql-api-interfaces';

export function findSiteByTitle(sites: Site[], title: string) {
  return sites.find((site) => site.title === title);
}
